import React from 'react';
import Modal from './Modal';

export default function DuplicateDocumentModal({
  show,
  filename,
  onCancel,
  onAddAsNewVersion,
  onUploadAsNewDocument,
  isLoading = false,
}) {
  return (
    <Modal
      show={show}
      title="Duplicate document"
      onCancel={onCancel}
      confirmText={null}
      cancelText={null}
      loading={isLoading}
      footer={
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end', width: '100%' }}>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onCancel}
            disabled={isLoading}
            style={{ fontWeight: '500', padding: '0.75rem 1.25rem', borderRadius: '8px', fontSize: '0.875rem' }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onAddAsNewVersion}
            disabled={isLoading}
            style={{ fontWeight: '600', padding: '0.75rem 1.25rem', borderRadius: '8px', fontSize: '0.875rem' }}
          >
            Add as New Version
          </button>
          <button
            type="button"
            className="btn btn-warning"
            onClick={onUploadAsNewDocument}
            disabled={isLoading}
            style={{ fontWeight: '600', padding: '0.75rem 1.25rem', borderRadius: '8px', fontSize: '0.875rem' }}
          >
            Upload as New Document (rename)
          </button>
        </div>
      }
      content={
        <div>
          <div
            className="duplicate-warning-box"
          >
            <i className="bi bi-exclamation-triangle-fill duplicate-warning-icon"></i>
            <div className="duplicate-warning-content">
              <div className="duplicate-warning-title">
                A document with this name already exists.
              </div>
              <div className="duplicate-warning-body">
                Would you like to:
                <ul className="duplicate-warning-list">
                  <li>
                    <strong>Add as New Version</strong> (recommended) — keep the same name and track history.
                  </li>
                  <li>
                    <strong>Upload as New Document</strong> — we will rename it by appending a timestamp.
                  </li>
                </ul>
                {filename ? (
                  <div className="duplicate-warning-filename">
                    Duplicate name: <span className="duplicate-warning-filename-value">{filename}</span>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
}
